import React, { useState } from 'react'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { Modal } from '@/molecules/Modal'
import { GroupTicketsDiscountExperiment } from '@/views/TicketCheckoutViews/ShowtimesView/components/modals/GroupTicketsModal/GroupTicketsDiscountExperiment'
import { GroupTicketsFaq } from '@/views/TicketCheckoutViews/ShowtimesView/components/modals/GroupTicketsModal/GroupTicketsFaq'
import { LastRodeoModal } from '@/views/TicketCheckoutViews/ShowtimesView/components/modals/GroupTicketsModal/LastRodeoModal'

const TICKET_PRICE = 15.0

export type GroupTicketsModalTypes = 'tickets' | 'faq'

export interface GroupTicketsModalProps {
  open: boolean
  onClose: () => void
  groupTicketProductVariantId: string
  theatricalSlug: string
  queryModal?: string
}

export const GroupTicketsModal = ({
  open,
  onClose,
  theatricalSlug,
  groupTicketProductVariantId,
  queryModal,
}: GroupTicketsModalProps) => {
  const [modalType, setModalType] = useState<GroupTicketsModalTypes>('tickets')
  if (queryModal === 'rodeo') {
    return (
      <>
        <Modal
          backgroundScreenColor="black"
          backgroundOverlayClassName="overflow-y-auto min-h-screen"
          className="z-[9999]"
          isOpen={open}
          transition="appear"
          panelClasses="!w-[calc(100%-2em)] overflow-hidden md:w-full !max-w-[560px] overflow-y-auto !p-6 !pt-12 md:!px-10 md:!pb-8 shadow-light-3 relative"
        >
          <div>
            <div
              className="pointer-events-none absolute inset-0 opacity-70"
              style={{
                backgroundImage:
                  'url("https://images.angelstudios.com/image/upload/v1744429452/the-last-rodeo/BKGD.jpg")',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                zIndex: -1,
              }}
            />
            <div
              className="absolute right-6 top-6 z-10 cursor-pointer rounded-full bg-core-gray-400 p-2"
              onClick={onClose}
            >
              <CloseIcon color="core-gray-700" size={16} />
            </div>
            <div className={' z-10'}>
              {modalType === 'tickets' && (
                <LastRodeoModal
                  theatricalSlug={theatricalSlug}
                  ticketPrice={TICKET_PRICE}
                  groupTicketProductVariantId={groupTicketProductVariantId}
                />
              )}

              {modalType === 'faq' && <GroupTicketsFaq setModalType={setModalType} />}
            </div>
          </div>
        </Modal>
      </>
    )
  }
  return (
    <Modal
      backgroundScreenColor="black"
      backgroundOverlayClassName="overflow-y-auto min-h-screen"
      className="z-[9999]"
      isOpen={open}
      transition="appear"
      panelClasses="!w-[calc(100%-2em)] md:w-full !max-w-[540px] overflow-y-auto !p-6 !pt-12 md:!px-10 md:!pb-8 shadow-light-3"
    >
      <div>
        <div className="absolute right-6 top-6 cursor-pointer rounded-full bg-core-gray-300 p-2" onClick={onClose}>
          <CloseIcon color="core-gray-700" size={16} />
        </div>

        <div>
          {modalType === 'tickets' && (
            <GroupTicketsDiscountExperiment
              theatricalSlug={theatricalSlug}
              setModalType={setModalType}
              ticketPrice={TICKET_PRICE}
              groupTicketProductVariantId={groupTicketProductVariantId}
            />
          )}

          {modalType === 'faq' && <GroupTicketsFaq setModalType={setModalType} />}
        </div>
      </div>
    </Modal>
  )
}
